module.exports = __webpack_public_path__ + "static/Logistics-581fff71169132c03d782c8fa49fa41a.jpg";